import React, { createContext, useState, useContext, useEffect } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
	// Initialize from localStorage if available, parse as number if present
	const [userRole, setUserRole] = useState(
		() => localStorage.getItem("userRole") || undefined
	);
	const [userId, setUserIdState] = useState(() => {
		const val = localStorage.getItem("userId");
		return val !== null ? Number(val) : undefined;
	});
	const [userCustomerId, setUserCustomerIdState] = useState(() => {
		const val = localStorage.getItem("userCustomerId");
		return val !== null ? Number(val) : undefined;
	});

	// Persist to localStorage on change
	useEffect(() => {
		if (userRole !== undefined) localStorage.setItem("userRole", userRole);
	}, [userRole]);
	useEffect(() => {
		if (userId !== undefined) localStorage.setItem("userId", String(userId));
	}, [userId]);
	useEffect(() => {
		if (userCustomerId !== undefined)
			localStorage.setItem("userCustomerId", String(userCustomerId));
	}, [userCustomerId]);

	// Ensure setUserId and setUserCustomerId always store numbers
	const setUserId = (val) =>
		setUserIdState(val !== undefined && val !== null ? Number(val) : undefined);
	const setUserCustomerId = (val) =>
		setUserCustomerIdState(
			val !== undefined && val !== null ? Number(val) : undefined
		);

	return (
		<UserContext.Provider
			value={{
				userRole,
				setUserRole,
				userId,
				setUserId,
				userCustomerId,
				setUserCustomerId,
			}}
		>
			{children}
		</UserContext.Provider>
	);
};

export const useUser = () => useContext(UserContext);
